(function(app) {

    app.provider("personApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function (personId) {
                        return complianceHubApiGateway.get("/People/" + personId);
                    };

                    service.getSsn = function (personId) {
                        return complianceHubApiGateway.get("/People/" + personId + "/SSN");
                    };

                    //PUTs
                    service.update = function (person) {
                        return complianceHubApiGateway.put("/People/" + person.Id, person);
                    };

                    service.updateSsn = function (personId, ssn) {
                        return complianceHubApiGateway.put("/People/" + personId + "/SSN", ssn);
                    };

                    //POSTs
                    service.addPerson = function(person) {
                        return complianceHubApiGateway.post("/People", person);
                    }

                    //DELETEs
                    service.removeSsn = function (personId) {
                        return complianceHubApiGateway.delete("/People/" + personId + "/SSN");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line